var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddSnap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 375,
    height: 375,
    viewBox: "0 0 375 375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_7",
    "data-name": "\\uADF8\\uB8F9 7",
    transform: "translate(-365 -337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_58",
    "data-name": "\\uC0AC\\uAC01\\uD615 58",
    transform: "translate(365 337)",
    fill: "#fff",
    stroke: "#e4e4e4",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 375,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 373,
    height: 373,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_193",
    "data-name": "\\uADF8\\uB8F9 193",
    transform: "translate(483 455)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_5",
    "data-name": "\\uC120 5",
    y2: 140,
    transform: "translate(70)",
    fill: "none",
    stroke: "#e4e4e4",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_6",
    "data-name": "\\uC120 6",
    y2: 140,
    transform: "translate(140 70) rotate(90)",
    fill: "none",
    stroke: "#e4e4e4",
    strokeWidth: 8
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSnap);
export default __webpack_public_path__ + "static/media/add_snap.73de3c29530fcca5ced7dc53eb1d11fe.svg";
export { ForwardRef as ReactComponent };